export const drawerWidth = 250;
export const secondaryPanelWidth = 400;
